import React, { memo } from 'react'
import SettingsPanel from '../../components/settings/SettingsPanel'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import LOG from '../../logging/Logger'

const SettingsSupport = memo(props => {
  LOG.debug('Render: SettingsSupport')

  return (
    <div>
      <SettingsPanel title='Documentation'>
        <Typography>
          <Link href='https://www.gettingfocused.com/guide' target='_blank'>
            User Guide
          </Link>
        </Typography>
      </SettingsPanel>
      <SettingsPanel title='Contact Us'>
        <Typography>
          <Link href='mailto:support@gettingfocused.com' target='_blank'>
            Email us - support@gettingfocused.com
          </Link>
        </Typography>
      </SettingsPanel>
    </div>
  )
})

export default SettingsSupport
